import React from "react";
import ReactDOM from "react-dom/client";
import { CookiesProvider } from "react-cookie";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AuthContextProvider } from "./store/auth-context";
import { MenuContextProvider } from "./store/menu-context";
import { AlertProvider } from "./store/alert-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AlertProvider>
      <CookiesProvider>
        <AuthContextProvider>
          <MenuContextProvider>
          <App />
          </MenuContextProvider>
        </AuthContextProvider>
      </CookiesProvider>
    </AlertProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//document.cookie="MSMTAMember=2246%7C2%7CMiri"
